module.exports = __webpack_public_path__ + "static/media/evidence_white-01.e8986346.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/evidence_white-01.png
// module id = 7697
// module chunks = 0